import {
  SimpleGrid,
  Text,
  Container,
  Center,
  Heading,
  Box,
} from "@chakra-ui/react";
import BoldSpinner from "components/BoldSpinner";
import EmptyNftCardWithLink from "components/EmptyNftCardWithLink";
import Panel from "components/Panel";
import { v2Name, v2OpenSeaUrl } from "config";
import useAssets from "hooks/useAssets";
import useTranslate from "hooks/useTranslate";
import { plural } from "pluralize";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import V2Card from "../components/V2Card";

const V2sContainer = () => {
  const translate = useTranslate();
  const navigate = useNavigate();
  const { v2sInWallet } = useAssets();

  const handleClick = useCallback(
    (tokenId: number) => {
      navigate(`/nfts/${tokenId}`);
    },
    [navigate]
  );

  if (v2sInWallet === undefined) {
    return (
      <Center h="52">
        <BoldSpinner size="xl" />
      </Center>
    );
  }

  return (
    <Container>
      <Panel>
        <Box mb="4" pl="2" mt="1.5">
          <Heading fontSize="2xl">
            {translate("v2s:title", {
              count: v2sInWallet.length,
              v2Name: plural(v2Name),
            })}
          </Heading>
          <Text fontSize="sm" mt="1" opacity="0.8">
            {translate("v2s:description", {
              v2Name: plural(v2Name),
            })}
          </Text>
        </Box>

        <SimpleGrid
          columns={{
            base: 2,
            sm: v2sInWallet.length > 1 ? 3 : 2,
          }}
          spacing="3"
          w="full"
        >
          {v2sInWallet
            .sort((a, b) => b - a)
            .map((tokenId) => (
              <V2Card
                key={tokenId}
                tokenId={tokenId}
                onClick={() => handleClick(tokenId)}
              >
                <Text fontWeight="600" px="1.5" pt="1.5">
                  #{tokenId}
                </Text>
              </V2Card>
            ))}

          <EmptyNftCardWithLink
            label={translate("common:buyOnOpenSea")}
            externalUrl={v2OpenSeaUrl}
          />
        </SimpleGrid>
      </Panel>
    </Container>
  );
};

export default V2sContainer;
